/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios'
import { devuelveBasePathPim } from '@utils'

// Función helper para obtener cookie sin dependencia externa
const getCookie = (name: string): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return undefined;
}

async function getResult () {
    const response = await axios.post(`${devuelveBasePathPim()}/auth/login`, {
      mail: process.env.REACT_APP_PIM_USERNAME,
      password: process.env.REACT_APP_PIM_PASSWORD
    })
    const result = response
    return result
}

// Promesa en vuelo para evitar múltiples logins simultáneos
let fetchingPimToken: Promise<string> | null = null

const ensurePimToken = async (): Promise<string> => {
    const stored = localStorage.getItem("bearerPim")
    if (stored) return stored

    // Si ya hay una solicitud en curso, esperarla en lugar de lanzar otra
    if (!fetchingPimToken) {
        fetchingPimToken = getResult()
            .then(result => {
                // Soporta tanto { token } como { accessToken } según lo que devuelva el backend PIM
                const token = result.data.token ?? result.data.accessToken
                if (token) localStorage.setItem("bearerPim", token)
                return token as string
            })
            .finally(() => {
                fetchingPimToken = null
            })
    }

    return fetchingPimToken
}

// Función helper para obtener el código del idioma actual
export const getCodigoIdiomaActual = (): string => {
    return getCookie('idioma') || 'es';
}

const instance = (idiomaCodigo?: string) => {
    const axiosInstance = axios.create({
        baseURL: devuelveBasePathPim()
    })

    axiosInstance.interceptors.request.use(async (config) => {
        const token = await ensurePimToken()

        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${token}`

        const codigoIdioma = idiomaCodigo || getCodigoIdiomaActual()
        if (codigoIdioma && codigoIdioma !== 'es') {
            config.headers['x-idioma-id'] = codigoIdioma
        }

        return config
    })

    return axiosInstance
}

export default instance
